function fireWBTPageview() {
  fireWBTPixel.call(this, 'adshow');
}

function fireWBTConversion(linkIdx = 0) {
  fireWBTPixel.call(this, 'adclick', linkIdx);
}

function fireWBTPixel(eventName, linkIdx) {
  const {
    bn = '', search_term = '', rtb = '', utm_content = '',
  } = this.pageParams;
  const { advertisers = [] } = this.adContext;
  // if it's impression pixel, always send the first advertiser
  const page = linkIdx ? advertisers[linkIdx] : advertisers[0];

  const wbtPixelUrl = `https://track.wbtapi.com/do?event_name=${eventName}&keyword=${search_term.replace(/\s/g, '+')}&adid=${utm_content}&referrer=${encodeURIComponent(
    this.win.location,
  )}&page=${page}&subid1=${bn}&subid2=${rtb}`;
  const pixel = this.doc.createElement('img');
  pixel.src = wbtPixelUrl;
  this.doc.head.append(pixel);
}

module.exports = {
  fireWBTPageview,
  fireWBTConversion,
};